import {
  LayoutDashboard, Package, ShoppingBag, Users, Ticket, Settings, BarChart3,
  ImageIcon, Truck, Tag, Megaphone, Palette, Globe, CreditCard,
} from "lucide-react";

// Keys yang WAJIB selalu aktif untuk semua paket (backend juga memaksa enabled).
export const ALWAYS_ON_KEYS = ["core.settings", "core.subscription"];

// Single source of truth: mapping menu dashboard tenant admin ↔ feature key.
// Template lain cukup deklarasi menu + featureKey dari catalog yang sama —
// tidak ada feature yang hardcoded ke template tertentu.
export const ADMIN_NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", exact: true, featureKey: "core.dashboard" },
  { to: "/admin/produk", icon: Package, label: "Produk", featureKey: "core.products" },
  { to: "/admin/kategori", icon: Tag, label: "Kategori", featureKey: "core.categories" },
  { to: "/admin/pesanan", icon: ShoppingBag, label: "Pesanan", featureKey: "core.orders" },
  { to: "/admin/pelanggan", icon: Users, label: "Pelanggan", featureKey: "core.customers" },
  { to: "/admin/promo", icon: Ticket, label: "Promo & Voucher", featureKey: "marketing.voucher" },
  { to: "/admin/banner", icon: ImageIcon, label: "Banner", featureKey: "marketing.banner" },
  { to: "/admin/popup", icon: Megaphone, label: "Popup Banner", featureKey: "marketing.popup_banner" },
  { to: "/admin/laporan", icon: BarChart3, label: "Laporan", featureKey: "reports.basic" },
  { to: "/admin/jubelio", icon: Truck, label: "Jubelio Shipment", featureKey: "integration.jubelio" },
  { to: "/admin/shipping", icon: Truck, label: "Shipping Settings", featureKey: "shipping.settings" },
  { to: "/admin/branding", icon: Palette, label: "Platform Branding", featureKey: "branding.platform" },
  { to: "/admin/seo", icon: Globe, label: "Platform SEO", featureKey: "seo.platform" },
  { to: "/admin/langganan", icon: CreditCard, label: "Langganan", featureKey: "core.subscription" },
  { to: "/admin/pengaturan", icon: Settings, label: "Pengaturan", featureKey: "core.settings" },
];
